import React, { StrictMode } from 'react'

// Providers
import { ThemeProvider } from 'styled-components'
import { QueryProvider } from './shared/services/reactQuery'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Layout } from './shared/components/Layout'

// Theme
import { GlobalStyle } from './shared/styles/globalStyle'
import { THEME } from './shared/styles/theme'

import Routes from './modules/Routes'

import { persistor, store } from './shared/store'
import useFirebase from './shared/hooks/useFirebase'

function App() {
	// useFirebase()
	return (
		<StrictMode>
			<GlobalStyle />
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<ThemeProvider theme={THEME}>
						<QueryProvider>
							<Layout>
								<Routes />
							</Layout>
						</QueryProvider>
					</ThemeProvider>
				</PersistGate>
			</Provider>
		</StrictMode>
	)
}

export default App
